/* import __COLOCATED_TEMPLATE__ from './algorithm-confirmation.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type Owner from '@ember/owner';

interface AlgorithmConfirmationDialogArgs {
  // Parameters
  title: string;
  close: () => void;
  oldAlgorithmButtonText?: string;
  newAlgorithmButtonText?: string;
  dialogClass?: string;
  getAlgorithm: (useV2: boolean) => void;
  hideCloseX?: boolean;
}
export default class AlgorithmConfirmationDialog extends Component<AlgorithmConfirmationDialogArgs> {
  @service declare intl: IntlService;

  @tracked showProsAndCons = false;
  @tracked hideExpandText;

  constructor(owner: Owner, args: AlgorithmConfirmationDialogArgs) {
    super(owner, args);
    this.hideExpandText = this.intl.t('dialogs.algorithm-confirmation.expand');
  }

  @action processNewAlgorithm(algorithm: boolean, closeDialog: () => void): void {
    // True is new, False, is old
    if (this.args.getAlgorithm) {
      this.args.getAlgorithm(algorithm);
    }
    closeDialog();
  }

  @action showExpandableArea(): void {
    this.showProsAndCons = !this.showProsAndCons;
    if (this.showProsAndCons) {
      this.hideExpandText = this.intl.t('dialogs.algorithm-confirmation.hide');
    } else {
      this.hideExpandText = this.intl.t('dialogs.algorithm-confirmation.expand');
    }
  }
}
